import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function ProtectedRoute() {
    const { isAuthenticated, isLoading } = useAuth();
    
    // Loading durumunda bekle
    if (isLoading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column',
                gap: '1rem'
            }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f4f6',
                    borderTop: '4px solid #7C3AED',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <p>Yükleniyor...</p>
            </div>
        );
    }
    
    // Basit kontrol: localStorage'da auth:user varsa giriş yapılmış
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    
    return <Outlet />;
}


